<template>
  <div class="t9_hf">
    <!-- 项目定制 -->
    <CitySelect></CitySelect>

    <div class="content">
      <div class="btn_map" v-if="showMap" @click="clickDiTuZhaoFang">
        <img src="https://assets.rurushishi.com//yq-rs-make/t9/btn_map.png" alt />
        地图找房
      </div>
      <!-- Banner -->
      <div class="banner">
        <swiper class="banner_swiper" ref="bannerSwiper" :options="banner.swiperOption">
          <swiperSlide v-for="(item,index) in bannerList" :key="index">
            <img v-if="!item.html" v-lazy="item.banner_imgurl" @click="tapBanner(item)" />
            <div style="width: 100%;height: 4rem;" v-if="item.html" v-html="item.html"></div>
          </swiperSlide>
          <div :style="swiperPagination" class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>

      <div>
        <TabSelect :prolist="projectList"></TabSelect>

        <div
          class="center_btns onlyzp"
          :class="{'hide_tj': HIDE_TJ}"
          v-if="!isShowCoupon&&!isHuafa"
        >
          <img :src="imgsrc" alt @click="clickGetMoney" />
        </div>
        <!-- 围观 -->
        <Visitors v-if="!isHuafa" style="margin-top:0.3rem;"></Visitors>
        <!-- 活动区配置 小程序环境下因为活动还不支持https暂时隐藏 -->
        <ActAreas v-if="isShowActAreas"></ActAreas>

        <!-- 华发资讯 -->
        <!-- <HfNews v-if="isHuafa&&dynamicList&&dynamicList.length>0" :list="dynamicList"></HfNews> -->
        <div v-if="isHuafa">
          <div class="line" v-if="dynamicList&&dynamicList.length>0"></div>
          <IndexModuleTitle
            v-if="dynamicList&&dynamicList.length>0"
            :initName="initName2"
            :initShowMore="false"
            v-on:tapMy="clickMoreNews"
          ></IndexModuleTitle>
          <IndexDynamic2 v-if="dynamicList&&dynamicList.length>0" :list="dynamicList"></IndexDynamic2>
        </div>
        <div v-else>
          <div class="line" v-if="dynamicList&&dynamicList.length>0"></div>
          <IndexModuleTitle
            v-if="dynamicList&&dynamicList.length>0"
            :initName="initName2"
            :initShowMore="false"
            v-on:tapMy="clickMoreNews"
          ></IndexModuleTitle>
          <IndexDynamic v-if="dynamicList&&dynamicList.length>0" :list="dynamicList"></IndexDynamic>
        </div>
      </div>
      <div class="line" v-if="projectList&&projectList.length>0"></div>
      <IndexModuleTitle
        v-if="projectList&&projectList.length>0"
        :initName="initName"
        :secName="secName"
        :initShowMore="isHuafa"
        v-on:tapMy="clickMoreProject"
      ></IndexModuleTitle>

      <div class="section_projects" v-if="!isHuafa">
        <div
          v-for="(project,projectIndex) in projectList"
          v-if="project.extinfo&&project.extinfo.buildingBanner"
        >
          <div class="projects" @click="tapProject(project)">
            <div class="projects_title">
              <div class="projects_name">{{project.extinfo.buildingName}}</div>
              <span class="projects_area">{{project.extinfo.unitPrice}}</span>
            </div>
            <div class="projects_adress">{{project.extinfo.address}}</div>
            <div class="projects_img">
              <!-- <img :src="project.extinfo.buildingBanner[0].main_img" /> -->
              <img :src="project.banner_imgurl" />
              <div
                v-for="(tag,tagIndex) in project.extinfo.advantage"
                v-if="tag&&tagIndex<4"
              >{{tag}}</div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="isHuafa">
        <projectList :showExt="true" :list="projectList"></projectList>
      </div>

      <AdComponent v-if="showAd.isShow" :my="showAd" v-on:close="showAd.isShow=false"></AdComponent>
      <Tabbar7></Tabbar7>
      <BtnHome></BtnHome>
    </div>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
const IndexModuleTitle = () => import("@/components/index_module-title");
const IndexDynamic = () => import("@/components/index_dynamic");
const IndexDynamic2 = () => import("@/components/index_dynamic2");
const BtnHome = () => import("@/components/btn_syshome");

import util from "@/utils/utils";
import * as comreq from "@/utils/comreq";
import { mapState, mapMutations } from "vuex";
import { MessageBox } from "mint-ui";
import Cookies from "js-cookie";

const Tabbar7 = () => import("@/components/tabbar7");
const Visitors = () => import("@/components/visitors");
const ActAreas = () => import("@/components/actareas");
const CitySelect = () => import("@/components/city_select");
const TabSelect = () => import("@/components/tab_select");
// const HfNews = () => import("@/components/hf_news");
const projectList = () => import("@/components/project_list");
const AdComponent = () => import("@/components/show_ad.vue");

export default {
  components: {
    swiper,
    swiperSlide,
    IndexModuleTitle,
    IndexDynamic,
    IndexDynamic2,
    Tabbar7,
    BtnHome,
    Visitors,
    CitySelect,
    TabSelect,
    ActAreas,
    AdComponent,
    // HfNews,
    projectList,
  },
  props: {},
  data() {
    return {
      //项目定制
      isHuafa: util.checkIsHuafa(), //是否华发
      isShowActAreas: true,
      initName: "",
      initName2: "看点",
      imgsrc: "",
      imgsrc2: "",
      secName: "",
      HIDE_TJ: false,
      showMap: false,
      // Banner
      banner: {
        swiperOption: {
          autoplay: {
            delay: 2500,
          },
          pagination: {
            el: ".swiper-pagination",
          },
        },
      },
      bannerList: [],
      dynamicList: [],
      projectList: [],
      couponChannelId: 0,
      isShowCoupon: false,

      showAd: {
        isShow: false,
        imgurl: "",
        url: "",
      },
      swiperPagination: null,
    };
  },
  watch: {},
  computed: {
    ...mapState([
      "isShowGuide",
      "isInMiniProgram",
      "receiveSpreadInfo",
      "shareSpreadInfo",
      "pageInfo",
      "userInfo",
    ]),
  },
  methods: {
    clickBuyCoupon() {
      //优惠购
    },
    clickGetCoupon() {
      //优惠券
    },
    clickGoAct() {
      //自定义配置活动
    },
    // clickGetCoupon() {
    //   if (this.couponChannelId != 0) {
    //     let appid = this.global.APPID;
    //     let openid = Cookies.get("openid");
    //     let url = `http://${appid}.web.ruthyx.com/act/online/rs-h5-t9-coupon/rs-h5-t9-coupon.html#/coupon-rule?channelId=${
    //       this.couponChannelId
    //     }&actAppId=${appid}&actOpenId=${openid}&fopenid=${
    //       this.receiveSpreadInfo.refereeopenid
    //     }&backurl=${encodeURIComponent(location.href)}`;
    //     util.openUrl(url);
    //   }
    // },
    // lj22
    clickGetMoney() {
      // if (util.checkIsHuafa()) {
      if (location.host.indexOf("whhf.") > -1) {
        MessageBox.alert("武汉地区暂未开放");
      } else {
        util.openYqRsMakeLink(
          util.addUrlParamFromObj(
            `${location.protocol}//${location.host}/h5/t9_zq_new`,
            {
              from: "t9",
            }
          )
        );
      }
    },
    clickGoFd() {
      window.location.href = `${location.protocol}//${location.host}/activities/housing-loan/index.html`;
    },
    clickBrand() {
      window.location.href = "https://dwz.cn/YNwmV56t";
    },
    clickNo() {
      MessageBox.alert("敬请期待");
    },
    clickMoreNews() {
      MessageBox.alert("敬请期待");
    },
    clickMoreProject() {
      // lj06
      util.openYqRsMakeLink(
        `${location.protocol}//${location.host}/h5/t9_project`
      );
    },
    tapBanner(item) {
      // banner_clickable  banner是否可点击字段。 0不可，1可。
      if (item.banner_clickable == 1) {
        if (item.banner_clickurl) {
          // lj05
          util.openUrl(item.banner_clickurl);
        } else if (item.h5PageUrlHttps) {
          // lj04
          util.openYqRsH5Link(item.h5PageUrlHttps);
        }
      }
    },
    // lj02 点击项目
    tapProject(item) {
      if (item.h5PageUrlHttps) {
        util.openYqRsMakeLink(item.h5PageUrlHttps);
      }
    },
    clickDiTuZhaoFang() {
      this.$router.push({
        name: "t9_map",
        query: {
          from: "t9",
        },
      });
    },
  },
  created() {
    // 华发一直展示活动配置组件，其它是小程序不展示
    if (util.checkIsHuafa()) {
      this.isShowActAreas = true;
    } else {
      if (this.isInMiniProgram) {
        this.isShowActAreas = false;
      } else {
        this.isShowActAreas = true;
      }
    }

    util
      .checkMapStateCallback(this, [
        "pageInfo",
        "receiveSpreadInfo",
        "userInfo",
      ])
      .then(() => {
        if (this.pageInfo.Extinfo) {
          if (this.pageInfo.Extinfo.content_pagetags) {
            let pagetagsObj = {
              // channel: null,
              // banner: null,
              // 热点新闻: null,
              // 精选项目: null
            };
            pagetagsObj.channel = {
              pagetags: this.pageInfo.Extinfo.content_channel_tags,
              tagname: this.pageInfo.Extinfo.content_channel_tags_name,
            };
            // this.couponChannelId = pagetagsObj.channel.pagetags;
            this.couponChannelId = this.pageInfo.Pid;
            this.pageInfo.Extinfo.content_pagetags.forEach((item) => {
              pagetagsObj[item.section] = item;
            });

            comreq
              .listPageInfoWithChannel2(
                pagetagsObj.channel.pagetags,
                pagetagsObj["banner"].pagetags
              )
              .then((data) => {
                if (data && data.list) {
                  data.list = data.list.map((item) => {
                    if (item.extinfo) {
                      item.extinfo = JSON.parse(item.extinfo);
                      if (item.extinfo.advantage) {
                        item.extinfo.advantage = item.extinfo.advantage.split(
                          ","
                        );
                      }
                    }
                    return item;
                  });
                  this.bannerList = data.list.map((item) => {
                    if (util.checkIsHuafa()) {
                      let mpPath = "";
                      if (item.mpUrl) {
                        mpPath = item.mpUrl;
                      } else if (
                        item.redirect_url &&
                        item.redirect_url.indexOf("/h5/coupon") > -1
                      ) {
                        let redirect_urlParam = util.getParamFromUrl(
                          item.redirect_url
                        );
                        mpPath = util.getXcxActAreasPath(
                          this,
                          redirect_urlParam.ctype,
                          redirect_urlParam.id,
                          redirect_urlParam.psn
                        );
                      }
                      if (mpPath) {
                        mpPath = util.handleH5OpenMpPath(mpPath);
                        let script = document.createElement("script");
                        script.type = "text/wxtag-template";
                        script.text = `${util.getMediaCssTxt()}<img style="border-radius: 0.125rem;width: 100%;height: 4rem;-o-object-fit: cover;object-fit: cover;" data-src="${
                          item.banner_imgurl
                        }" src="${item.banner_imgurl}" lazy="loaded">`;
                        let html = `<wx-open-launch-weapp style="width: 100%;height: 4rem;display:block" username="${util.getOriginalId()}" path="${mpPath}">${
                          script.outerHTML
                        }</wx-open-launch-weapp>`;
                        item.html = html;
                        this.swiperPagination = {
                          bottom: "40px",
                        };
                      }
                    }
                    return item;
                  });
                }
                console.log("banner", JSON.parse(JSON.stringify(data)));
              });

            comreq
              .listPageInfoWithChannel2(
                pagetagsObj.channel.pagetags,
                pagetagsObj["热点新闻"].pagetags
              )
              .then((data) => {
                if (data && data.list) {
                  data.list = data.list.map((item) => {
                    if (item.extinfo) {
                      item.extinfo = JSON.parse(item.extinfo);
                      if (item.extinfo.advantage) {
                        item.extinfo.advantage = item.extinfo.advantage.split(
                          ","
                        );
                      }
                    }
                    return item;
                  });
                  this.dynamicList = data.list;
                }
                console.log("热点新闻", JSON.parse(JSON.stringify(data)));
              });

            comreq
              .listPageInfoWithChannel2(
                pagetagsObj.channel.pagetags,
                pagetagsObj["精选项目"].pagetags
              )
              .then((data) => {
                if (data && data.list) {
                  data.list = data.list.map((item) => {
                    if (item.extinfo) {
                      item.extinfo = JSON.parse(item.extinfo);
                      if (item.extinfo.advantage) {
                        item.extinfo.advantage = item.extinfo.advantage.split(
                          ","
                        );
                      }
                    }
                    return item;
                  });

                  //武汉华发外滩首府 3402 北京华发颐园 3408  上海华发公馆 3422 上海华发四季 3421 测试 2358 排列到最后
                  let tmp1 = [];
                  let tmp2 = [];
                  data.list.forEach((e) => {
                    if (
                      e.pid == 3402 ||
                      e.pid == 3408 ||
                      e.pid == 3422 ||
                      e.pid == 3421 ||
                      e.pid == 2358
                    ) {
                      tmp2.push(e);
                    } else {
                      tmp1.push(e);
                    }
                  });
                  // this.projectList = data.list;
                  this.projectList = tmp1.concat(tmp2);
                }
                console.log("精选项目", JSON.parse(JSON.stringify(data)));
              });
          }

          //判断我要推荐
          if (
            this.pageInfo.Extinfo.open_recommend != undefined &&
            this.pageInfo.Extinfo.open_recommend == 0
          ) {
            this.HIDE_TJ = true;
          }
          if (
            this.pageInfo.Extinfo.open_recommend == 1 &&
            this.pageInfo.Extinfo.recommendConfig &&
            this.pageInfo.Extinfo.recommendConfig.recommend_banner_img
          ) {
            this.imgsrc = this.pageInfo.Extinfo.recommendConfig.recommend_banner_img;
          }
          console.log("Extinfo>>>", this.pageInfo.Extinfo);
          //判断是否展示弹窗
          if (
            this.pageInfo.Extinfo.adConfig &&
            this.pageInfo.Extinfo.adConfig.open_ad == 1
          ) {
            //如果当前没有弹出过且广告过期时间之内则取广告数据弹出
            let curTime = new Date().getTime();
            let key = "popup_ad_" + this.pageInfo.PageId;
            if (
              !Cookies.get(key) &&
              curTime < this.pageInfo.Extinfo.adConfig.validTime
            ) {
              comreq.adInfo(this.pageInfo.Extinfo.adConfig.adId).then((res) => {
                if (res.status == 1 && res.imgurl) {
                  this.showAd = {
                    isShow: true,
                    imgurl: res.imgurl,
                    url: res.url,
                    miniUrl: res.miniUrl,
                  };
                  Cookies.set(key, 1, {
                    expires: 1,
                  });
                }
              });
            }
          }
        }
      });
  },
  mounted() {
    let that = this;
    that.initName = "精选项目";
    if (util.checkIsHuafa()) {
      that.showMap = false;
      that.initName2 = "热门活动";
      that.secName = "点击项目了解详情，在线咨询";
      that.imgsrc =
        "https://assets.rurushishi.com//yq-rs-make/t9/t9_woyaozhuanqian5.png";
      // that.imgsrc2 =
      //   "https://assets.rurushishi.com//yq-rs-make/t9/t9_woyaozhuanqian3.png?x-oss-process=image/resize,p_100";
    } else if (
      location.host.indexOf("shxyh.") > -1 ||
      location.host.indexOf("yunmeiha.") > -1
    ) {
      //星河湾相关域名
      that.showMap = true;
      that.imgsrc =
        "https://assets.rurushishi.com//yq-rs-make/t9/t9_woyaozhuanqian5.png";
      // that.imgsrc2 =
      //   "https://assets.rurushishi.com//yq-rs-make/t9/t9_woyaozhuanqian3.png?x-oss-process=image/resize,p_100";
    } else {
      that.showMap = true;
      that.imgsrc =
        "https://assets.rurushishi.com//yq-rs-make/t9/t9_woyaozhuanqian4.png?x-oss-process=image/resize,p_100";
      // that.imgsrc2 =
      //   "https://assets.rurushishi.com//yq-rs-make/t9/t9_woyaozhuanqian.png?x-oss-process=image/resize,p_100";
    }
  },
};
</script>
<style lang="css" scoped>
.btn_map {
  background-color: #f1f1f1;
  height: 0.8rem;
  line-height: 0.8rem;
  width: 90%;
  margin: 0.2rem auto 0 auto;
  border-radius: 5px;
  text-align: center;
}
.btn_map > img {
  height: 0.35rem;
  width: 0.35rem;
  vertical-align: text-top;
}
/* Banner */
.banner_swiper {
  width: 100%;
  margin: 0.2rem auto 0 auto;
}
.banner_swiper img {
  width: 100%;
  display: block;
  height: 3.4rem;
  border-radius: 0.125rem;
}

.banner_swiper .swiper-slide {
  width: 90% !important;
  margin: 0 5%;
}
.swiper-slide-prev {
  right: -8%;
}
.swiper-slide-next {
  left: -8%;
}
.center_btns {
  width: 96%;
  display: flex;
  justify-content: space-around;
  margin: 0.25rem auto 0 auto;
}
.center_btns.c2 {
  margin: 0.1rem auto 0 auto;
}
.center_btns > img {
  width: 3.5rem;
  height: 1.15rem;
}
.center_btns.onlyzp > img {
  width: 94%;
}
.line {
  width: 100%;
  height: 5px;
  background-color: #f5f5f5;
  margin-top: 0.25rem;
}

/* 精选项目 */
.section_projects {
  width: 100%;
  padding-bottom: 20px;
}

.projects {
  width: 90%;
  min-height: 190px;
  padding: 20px 0;
  margin-left: 5%;
  border-bottom: 1px solid #f7f7f7;
}

.projects_title {
  width: 100%;
  height: 30px;
}

.projects_title .projects_name {
  width: 200px;
  overflow: hidden;
  line-height: 25px;
  font-size: 16px;
  color: #000;
  float: left;
  box-sizing: border-box;
}

.projects_title .projects_area {
  box-sizing: border-box;
  width: 100px;
  line-height: 25px;
  float: right;
  text-align: center;
  color: #959595;
  overflow: hidden;
  font-size: 16px;
  display: -webkit-box;
  color: #f0502b;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  height: 50px;
}

.projects_adress {
  color: #7f7f7f;
  line-height: 25px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.projects_img {
  overflow: hidden;
  clear: both;
}

.projects_img > img {
  width: 64%;
  height: 2.8rem;
  float: left;
  margin-right: 5%;
}

.projects_img > span {
  width: 30%;
  color: #000;
  display: inline-block;
  float: right;
}

.projects_img > div {
  width: 30%;
  height: 27.5px;
  font-size: 12px;
  margin-top: 4px;
  border-radius: 10px;
  line-height: 27.5px;
  display: block;
  text-align: center;
  padding: 0 5px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: 1px solid #959595;
  float: left;
  color: #4d4d4d;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/** 项目定制 **/
.content.sf {
  position: relative;
  background-color: #fff;
  padding-top: 0.1rem;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  margin-top: -0.2rem;
}
.content.sf .banner_swiper {
  width: 96%;
}
.content.sf .banner_swiper img {
  width: 98%;
  margin: 0 auto;
}
.content.sf .banner_swiper .swiper-slide {
  width: 100% !important;
  margin: 0;
}
.content.sf .swiper-slide-prev {
  right: 0;
}
.content.sf .swiper-slide-next {
  left: 0;
}
.content.sf >>> .swiper-pagination .swiper-pagination-bullet {
  width: 25px;
  height: 4px;
  margin: 0 2px;
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 0;
  opacity: 1;
}
.content.sf >>> .swiper-pagination .swiper-pagination-bullet-active {
  background-color: #fff;
  opacity: 1;
}
.sf-bg-layer > img {
  width: 100%;
  display: block;
}
.sf-btn-layer {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0.2rem;
}
.sf-btn-layer .icon-layer {
  flex: 1;
  padding-top: 0.9rem;
  text-align: center;
  font-size: 0.26rem;
  color: #d3541e;
}
.sf-btn-layer .icon-layer.i1 {
  background: url("https://assets.rurushishi.com//yq-rs-make/t9/shuofeng/icon1.png")
    no-repeat top center;
  background-size: 0.7rem 0.7rem;
}
.sf-btn-layer .icon-layer.i2 {
  background: url("https://assets.rurushishi.com//yq-rs-make/t9/shuofeng/icon2.png")
    no-repeat top center;
  background-size: 0.7rem 0.7rem;
}
.sf-btn-layer .icon-layer.i3 {
  background: url("https://assets.rurushishi.com//yq-rs-make/t9/shuofeng/icon3.png")
    no-repeat top center;
  background-size: 0.7rem 0.7rem;
}
.sf-btn-layer .icon-layer.i4 {
  background: url("https://assets.rurushishi.com//yq-rs-make/t9/shuofeng/icon4.png")
    no-repeat top center;
  background-size: 0.7rem 0.7rem;
}
.hide_tj {
  display: none;
}
</style>